import createVueApp from '@/common/create_app'

Styxie.Initializers.UsersRegistrations = {
  new: async(props) => {
    const { default: RegistrationsNew } = await import('@/vue_widgets/users/registrations/new/index.vue')
    createVueApp(RegistrationsNew, { props, layout: null })
  }
}
